import {
  SET_PURPOSEOFTRANSFER,
  SET_PURPOSEOFTRANSFERNAME,
  GET_ALLOWED_PURPOSEOFTRANSFERS_REQUEST,
  GET_ALLOWED_PURPOSEOFTRANSFERS_SUCCESS,
  GET_ALLOWED_PURPOSEOFTRANSFERS_FAILURE,
  CLEANUP,
} from "./selectPurposeOfTransferType";

import { geRemittanceCode } from "api/api";

export const cleanup = () => {
  return {
    type: CLEANUP,
  };
};

export const setPurposeOfTransfer = (purposeOfTransfer) => {
  return {
    type: SET_PURPOSEOFTRANSFER,
    purposeOfTransfer: purposeOfTransfer,
  };
};

export const setPurposeOfTransferName = (purposeOfTransferName) => {
  return {
    type: SET_PURPOSEOFTRANSFERNAME,
    purposeOfTransferName: purposeOfTransferName,
  };
};

const getAllowedPurposeOfTransfersRequest = () => {
  return {
    type: GET_ALLOWED_PURPOSEOFTRANSFERS_REQUEST,
  };
};

const getAllowedPurposeOfTransfersSuccess = (payload) => {
  return {
    type: GET_ALLOWED_PURPOSEOFTRANSFERS_SUCCESS,
    payload: payload,
  };
};

const getAllowedPurposeOfTransfersFailure = (error) => {
  return {
    type: GET_ALLOWED_PURPOSEOFTRANSFERS_FAILURE,
    payload: error,
  };
};

export const getAllowedPurposeOfTransfers = () => {
  return async (dispatch) => {
    dispatch(getAllowedPurposeOfTransfersRequest());
    try {
      var response = await geRemittanceCode();

      // return data
      dispatch(getAllowedPurposeOfTransfersSuccess(response));
    } catch (error) {
      dispatch(getAllowedPurposeOfTransfersFailure(error.message));
    }
  };
};
